import React from 'react'

import styled from '@emotion/styled'
import { TFunction } from 'i18next'

import { Restore } from '@surglogs-app/icons'
import {
  Title,
  Text,
  Divider,
  FlexBox,
  Box,
  Button,
  Input,
  InfoBox,
} from '@surglogs-app/ui'
import { LogoComponentLoader } from '@surglogs-app/ui.loader'

import { CopyButton } from './CopyButton'
import { MfaAuthenticatorAppQrCode } from './MfaAuthenticatorAppQrCode'

interface MfaAuthenticatorAppSetupProps {
  isPending: boolean
  code: string | null
  email: string
  initiateMFASetup: () => void
  t: TFunction<any>
  showTitle?: boolean
  showDivider?: boolean
}

const ResponsiveFlexBox = styled(FlexBox)`
  flex-direction: column;
  align-items: center;

  @media ${({ theme }) => theme.mq.lg} {
    flex-direction: row;
  }

  @media ${({ theme }) => theme.mq.xl} {
    flex-direction: row;
  }
`

export const MfaAuthenticatorAppSetup = ({
  isPending,
  code,
  email,
  t,
  initiateMFASetup,
  showTitle = true,
  showDivider = true,
}: MfaAuthenticatorAppSetupProps) => {
  return (
    <>
      {showTitle ? (
        <Title {...{ mt: 'abs.0' }}>{t('mfaSetup.step1.title')}</Title>
      ) : null}
      <Text>{t('mfaSetup.step1.description')}</Text>
      {showDivider ? <Divider {...{ my: 'abs.30', mx: 'abs.0' }} /> : null}
      {isPending ? (
        <FlexBox {...{ h: '200px' }}>
          <LogoComponentLoader />
        </FlexBox>
      ) : code ? (
        <ResponsiveFlexBox {...(showDivider ? {} : { mt: 'md' })}>
          <MfaAuthenticatorAppQrCode {...{ email, code }} />

          <Box {...{ margin: 'xl' }}>
            <Text>{t('mfaSetup.step1.additionalInfo')}</Text>

            <FlexBox {...{ mt: 'md' }}>
              <Input {...{ defaultValue: code, readOnly: true, flex: 1 }} />
              <CopyButton {...{ value: code }} />
            </FlexBox>
          </Box>
        </ResponsiveFlexBox>
      ) : (
        <InfoBox {...{ variant: 'warning' }}>
          <Text>{t('mfaSetup.step1.errorWhileLoadingSetup')}</Text>
          <Button
            {...{
              icon: Restore,
              size: 'mini',
              variant: 'secondary',
              onClick: initiateMFASetup,
            }}>
            {t('mfaSetup.tryAgain')}
          </Button>
        </InfoBox>
      )}
    </>
  )
}
